import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Gamepad2, FolderTree, Megaphone, Settings, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "./AuthContext";

const NAV = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard", id: "dashboard" },
  { to: "/admin/giochi", icon: Gamepad2, label: "Giochi", id: "games" },
  { to: "/admin/categorie", icon: FolderTree, label: "Categorie", id: "categories" },
  { to: "/admin/pubblicita", icon: Megaphone, label: "Pubblicità", id: "ads" },
  { to: "/admin/impostazioni", icon: Settings, label: "Impostazioni", id: "settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="gg-admin min-h-screen md:flex">
      <aside className="md:w-60 md:min-h-screen bg-[#0d2233] border-b md:border-b-0 md:border-r border-white/10 p-4 flex md:flex-col gap-2 overflow-x-auto">
        <Link to="/admin" className="hidden md:flex items-center gap-2 mb-6 text-white font-bold text-lg" style={{ fontFamily: "Oswald" }}>
          <img src="/favicon.svg" alt="" className="w-8 h-8" /> Admin
        </Link>
        {NAV.map((n) => (
          <NavLink
            key={n.id}
            to={n.to}
            end={n.end}
            data-testid={`admin-nav-${n.id}`}
            className={({ isActive }) =>
              `flex items-center gap-2 rounded-lg px-3 py-2 text-sm whitespace-nowrap transition-colors ${isActive ? "bg-[#fc0] text-[#043856] font-bold" : "text-slate-200 hover:bg-white/10"}`
            }
          >
            <n.icon size={16} /> {n.label}
          </NavLink>
        ))}
        <div className="md:mt-auto flex md:flex-col gap-2">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-slate-200 hover:bg-white/10 whitespace-nowrap" data-testid="admin-view-site">
            <ExternalLink size={16} /> Vedi sito
          </a>
          <button onClick={logout} className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-slate-200 hover:bg-white/10 whitespace-nowrap" data-testid="admin-logout-btn">
            <LogOut size={16} /> Esci
          </button>
          <p className="hidden md:block text-xs text-slate-400 px-3 truncate">{user?.email}</p>
        </div>
      </aside>
      <main className="flex-1 p-4 md:p-8 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
